import { groupTypeLabel } from '../sp-group-type/sp-group-type.exports';

export class Controller {

    $onChanges() {
        this.groupTypeLabel = groupTypeLabel(this.groupType);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-name/sp-group-name.controller.js